
import { Route } from '@/app/router'

const Plan = () => import('./index.vue')

const PlanProps = ['page', 'perPage']

const PlanMeta = {
	sort: 4,
	displayInSidebar: true,
	displayName: 'plan',
	icon: 'fal file-signature',
	activeIcon: 'fas file-signature'
}

export default [
	new Route('/plan', Plan)
		.as('Dashboard:Plan')
		.meta(PlanMeta)
		.permissions(['VIEW_PLANS'])
		.props(PlanProps)
]
